type dataType =
  | 'string'
  | 'number'
  | 'bigint'
  | 'boolean'
  | 'symbol'
  | 'undefined'
  | 'object'
  | 'function'

const storageFns = {
  local: localStorage,
  session: sessionStorage,
}

interface StorageProps {
  storageType?: keyof typeof storageFns
}


export const setStorage = (key: string, data: any, params?: StorageProps) => {
  const { storageType = 'local' } = params || {}
  const storage = storageFns[storageType]
  // 如果data不是str 就要转str
  const dataType = typeof data
  const setData = {
    data,
    type: dataType,
  }
  storage.setItem(key, JSON.stringify(setData))
}


export const getStorage = (key: string, params?: StorageProps) => {
  const { storageType = 'local' } = params || {}
  const storage = storageFns[storageType]
  const storageData = storage.getItem(key)
  if (!storageData) return storageData
  try {
    const resData = JSON.parse(storageData)
    const dataType: dataType = resData.type
    const { data } = resData

    // 布尔值 返回data
    if (dataType === 'boolean') return data === true
    // 对象返回
    if (dataType === 'string' && data === 'null') {
      return null
    }
    // z字符串返回
    if (dataType === 'string' && data === 'undefined') return undefined
    // number
    if (dataType === 'number') return Number(data)
    return data
  } catch (error) {
    return storageData
  }
}

export const removeStorage = (key: string, params?: StorageProps) => {
  const { storageType = 'local' } = params || {}
  const storage = storageFns[storageType]
  storage.removeItem(key)
}

const onStorage = {
  getItem: getStorage,
  setItem: setStorage,
  removeStorage,
}

export default onStorage
